import queryString from 'query-string';

const get = () => {
  return queryString.parse(location.search);
}

const stringify = (obj: any) => {
  return queryString.stringify(obj);
};

export default {
  get,
  stringify
};



// WEBPACK FOOTER //
// ./packages/platform-utils/queryString.ts